(() => {
    function registerInputField() {
        Alpine.data('inputField', () => ({
            showPassword: false,

            togglePassword() {
                this.showPassword = !this.showPassword;
            },
        }));
    }

    if (typeof Alpine !== 'undefined' && Alpine.version) {
        registerInputField();
    } else {
        document.addEventListener('alpine:init', () => {
            registerInputField();
        });
    }
})();
